<template>
  <div class="catalog__catalog-item-form">
    <input
      class="input-conditions"
      :class="inputClass"
      :value="value"
      type="text"
      placeholder="Поиск"
      @input="input($event.target.value)"
      @keypress.enter="search"
      @blur="search">
    <reset-button v-if="value" @mousedown.native.stop.prevent @click="input('', true)" class="catalog__input-btn-reset" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  SEARCH,
  SET_TABLE_FILTER
} from '@/store/actions/search'

export default {
  name: 'table-filter-input',
  props: {
    filter: {
      type: String,
      require: true
    },
    inputClass: [String, Array, Object]
  },
  data: () => ({
    edited: false
  }),
  computed: {
    value () {
      return this.getTableFilter[this.filter]
    },
    ...mapGetters(['getTableFilter'])
  },
  methods: {
    input (value, search = false) {
      this.edited = true
      const { filter } = this
      this.$store.dispatch(SET_TABLE_FILTER, { filter, value }).then(() => {
        if (search) this.search()
      })
    },
    search () {
      if (this.edited) {
        this.edited = false
        const { $router: router } = this
        this.$store.dispatch(SEARCH, { router })
      }
    }
  }
}
</script>
